import React, { useMemo, useState } from 'react';
import Dialog from '../../../Components/Dialog';
import ShowEventWidget from './ShowEventWidget';
import { useAtomValue } from 'jotai';
import { activityTypesAtom } from '../../../Atoms';
import { ACTIVITY_TYPES_DIALOGS } from '../../../Utils/constants/activityTypes';

const EventDetailsDialog = function EventDetailsDialog({
  open,
  onClose,
  outcomes,
  setEdit,
  handleEndAppointment,
  event,
}) {
  const activityTypes = useAtomValue(activityTypesAtom);

  const [activityDialog, setActivityDialog] = useState(null);

  const handleOpenActivityDialog = (appointmentData) => {
    const actType = activityTypes.find(
      ({ id }) => id === appointmentData.nextActivity
    )?.name;
    setActivityDialog({ ...appointmentData, actType });
  };

  const handleCloseActivityDialog = () => {
    setActivityDialog(null);
  };

  const ActivityDialog = useMemo(
    () => ACTIVITY_TYPES_DIALOGS[activityDialog?.actType] || null,
    [activityDialog]
  );
  return (
    <>
      {ActivityDialog && (
        <ActivityDialog
          open={Boolean(activityDialog)}
          onClose={handleCloseActivityDialog}
          onSubmit={(data) => {
            const { campaignId, parentId, entityId, ...rest } = data;
            const payload = {
              nextActivityData: rest,
              campaignId,
              parentId,
              entityId,
              outcome: activityDialog?.outcome,
            };
            handleEndAppointment(payload, handleCloseActivityDialog);
          }}
          entityId={event?.entityId}
          commercialCampaignId={event?.commercialCampaignId}
          parentId={event?.appointmentId}
        />
      )}
      <Dialog
        id="appointment-details-dialog"
        open={open}
        onClose={onClose}
        width="sm"
        fullWidth
        padding={0}
      >
        <ShowEventWidget
          outcomes={outcomes}
          handleEndAppointment={handleEndAppointment}
          handleOpenActivityDialog={handleOpenActivityDialog}
          setEdit={setEdit}
          close={onClose}
          event={event}
        />
      </Dialog>
    </>
  );
};

export default EventDetailsDialog;
